var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1719_6056)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 47.9236,
    height: 47.3462,
    rx: 11.4331,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1719_6056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5676 15H19.6509C18.7379 15 18 15.7484 18 16.6743V38.3305C18 39.2564 18.7379 40.0048 19.6509 40.0048H36.3491C37.2621 40.0048 38 39.2564 38 38.3305V24.4847C38 24.0386 37.825 23.6116 37.5128 23.295L29.7266 15.4846C29.4191 15.1727 29.0028 15 28.5676 15Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 23.7843L29.2441 15V22.11C29.2441 23.0359 29.9821 23.7843 30.895 23.7843H37.9953H38.0001Z",
    fill: "#AB54A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8307 28.9032H21.9357C21.3917 28.9032 20.9518 28.4571 20.9518 27.9054C20.9518 27.3536 21.3917 26.9075 21.9357 26.9075H29.8307C30.3747 26.9075 30.8146 27.3536 30.8146 27.9054C30.8146 28.4571 30.3747 28.9032 29.8307 28.9032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5554 33.0292H21.9357C21.3917 33.0292 20.9518 32.5831 20.9518 32.0313C20.9518 31.4796 21.3917 31.0334 21.9357 31.0334H32.5601C33.1041 31.0334 33.544 31.4796 33.544 32.0313C33.544 32.5831 33.1041 33.0292 32.5601 33.0292H32.5554Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1719_6056",
    x: 0.57006,
    y: 0.57006,
    width: 59.3567,
    height: 58.7793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.28663,
    dy: 2.28663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.403922 0 0 0 0 0.517647 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1719_6056"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1719_6056",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1719_6056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 25,
    fill: "white",
    transform: "translate(18 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.2d40e20d3e7700eaa44450712be5a2f7.svg";
export { ForwardRef as ReactComponent };